import { Button } from 'antd'
import React, { useState } from 'react'

import { BODY_PARTS } from '../../../constants'
import { useNextPhase } from '../../../hooks/useNextPhase'
import { BodyPartSelector, VERTICAL } from './BodyPartSelector'
import { useParams } from 'react-router-dom'
import { SubjectType } from '../../../Types'
import { useMoveForwardNoEligibility } from '../../../hooks/useSubject'

type Props = {
  onClose: () => void
  navigateToTerminate: () => void
  subjectData: SubjectType
  setDrawerSize: (size: string) => void
}
export const NoEligibilityView = ({ onClose }: Props) => {
  const { projectId, subjectId } = useParams() as { projectId: string; subjectId: string }

  const [selectedBodyPart, setSelectedBodyPart] = useState<typeof BODY_PARTS>()

  const { callMoveForwardNoEligibility, isLoading } = useMoveForwardNoEligibility(projectId, subjectId)

  // Since we have no eligibility, we need the body parts of the next phase they are getting moved to
  const { data: nextPhase } = useNextPhase(projectId, subjectId)

  const eligibleBodyParts =
    nextPhase && nextPhase.bodyParts
      ? nextPhase.bodyParts.map((item) => {
          return { bodyPart: item, label: BODY_PARTS[item] || item }
        })
      : []

  const handleMove = () => {
    console.log('Moving subject to next phase with body part:', selectedBodyPart)

    const obj = {
      subjectId: subjectId,
      bodyPart: selectedBodyPart,
      projectId: projectId,
    }

    return callMoveForwardNoEligibility(obj)
      .then((result) => {
        console.log('NoEligibilityView > result = ', result)
        onClose()
        return result
      })
      .catch((error) => {
        console.error('Error moving subject forward:', error)
      })
  }

  return (
    <>
      <div className="col-12 mb-2">
        <h3>Move Subject to the Next Phase</h3>

        {nextPhase && nextPhase.bodyParts.length !== 0 ? (
          <>
            <p className="fw-bold mt-3 mb-2">Confirm target body part</p>
            <p className="">
              To advance the subject to the next study phase, select the correct target body part below.
            </p>
          </>
        ) : (
          <>
            <p className="opacity-75">You are about to move the subject to the next phase of the study.</p>
          </>
        )}
      </div>

      <div className="col-12">
        <BodyPartSelector
          className="row mt-3"
          direction={VERTICAL}
          bodyparts={eligibleBodyParts}
          setSelectedBodyPart={setSelectedBodyPart}
        />
      </div>

      <div className="col-12 opacity-50">
        <hr />
      </div>

      <div className="col-12 d-flex justify-content-end ">
        <Button className="me-2 px-5" onClick={onClose}>
          Cancel
        </Button>
        <Button
          className="px-5"
          type="primary"
          disabled={!selectedBodyPart && eligibleBodyParts.length !== 0}
          onClick={handleMove}
          loading={isLoading}
        >
          Move to next phase
        </Button>
      </div>
    </>
  )
}
